import user_agent_classes from "../modules/user_agent_classes";
import clear_blur from "../modules/clear_blur";
import herald_header_check from "../functions/herald_header_check";
import resizing from "../modules/resizing";
import featured_area_hovers from "../modules/featured_area_hovers";
import search from "../modules/search";
import share_this from "../modules/share_this";
import body from "../modules/body";
import slider from "../modules/slider";
import trending from "../modules/trending";
import herald_gallery from "../functions/herald_gallery";
import infinity_scroll from "../modules/infinity_scroll";
import load_more from "../modules/load_more";
import herald_responsive_header_ad from "../functions/herald_responsive_header_ad";
import back_to_top from "../modules/back_to_top";
import herald_center from "../modules/herald_center";
import smooth_scroll from "../modules/smooth_scroll";

$(document).ready(function () {
    user_agent_classes();
    clear_blur();
    herald_header_check();
    resizing();
    featured_area_hovers();
    search();
    share_this();
    body();
    slider();
    trending();
    herald_gallery($('.herald-section'));
    infinity_scroll();
    load_more();
    herald_responsive_header_ad();
    back_to_top();
    herald_center();
    smooth_scroll();
});
